import useReveal from '../../hooks/useReveal';
import { scrollPageToTop } from '../../utils/properties';

const SERVICES = [
  {
    icon: 'fa-hand-holding-usd',
    title: 'Financing guidance',
    desc: 'Listers and investors get clarity on raise structure, minimum tickets, and how fractional ownership fits your capital plan.',
    href: '/view-listings',
    cta: 'Explore listings',
    onClick: (handlers) => (e) => {
      e.preventDefault();
      scrollPageToTop();
      handlers.onViewListings?.();
    },
  },
  {
    icon: 'fa-clipboard-check',
    title: 'Reviewed offerings',
    desc: 'Every sale listing passes admin review: share structure, offering timeline, property manager details, and documents before go-live.',
    href: '/list-property',
    cta: 'List your property',
    onClick: (handlers) => (e) => {
      e.preventDefault();
      handlers.setPage?.('list-property');
    },
  },
  {
    icon: 'fa-chart-line',
    title: 'Portfolio & tokens',
    desc: 'Track USD wallet balance, on-chain share tokens, favorites, and compare listings across markets.',
    href: '/register',
    cta: 'Create Free Account',
    onClick: (handlers) => (e) => {
      e.preventDefault();
      handlers.setPage?.(handlers.isLoggedIn ? 'dashboard' : 'register');
    },
  },
];

const HomeServicesSection = ({ setPage, onViewListings, isLoggedIn }) => {
  const [ref, visible] = useReveal();
  const handlers = { setPage, onViewListings, isLoggedIn };

  return (
    <section ref={ref} className="home-services" aria-labelledby="home-services-heading">
      <div className="home-services-inner">
        <header className="home-services-header">
          <div className={`reveal-up ${visible ? 'visible' : ''} home-process-eyebrow`}>
            <div className="home-process-eyebrow-line" aria-hidden="true"></div>
            <span className="home-process-eyebrow-text">Full-service support</span>
            <div className="home-process-eyebrow-line home-process-eyebrow-line--reverse" aria-hidden="true"></div>
          </div>
          <h2
            id="home-services-heading"
            className={`reveal-up delay-1 ${visible ? 'visible' : ''} home-services-title`}
          >
            We help you manage the full<br />
            <em>real estate journey</em>
          </h2>
        </header>

        <div className="home-services-grid">
          {SERVICES.map((item, i) => (
            <article
              key={item.title}
              className={`reveal-up delay-${i + 2} ${visible ? 'visible' : ''} home-service-card`}
            >
              <div className="home-service-card-icon" aria-hidden="true">
                <i className={`fas ${item.icon}`}></i>
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
              <a href={item.href} onClick={item.onClick(handlers)}>
                {item.cta} <i className="fas fa-arrow-right" aria-hidden="true"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeServicesSection;
